var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33275 4.4668L1.53275 0.733464C1.26608 0.466798 0.866081 0.466798 0.599414 0.733464C0.332747 1.00013 0.332747 1.40013 0.599414 1.6668L3.86608 5.00013L0.599414 8.33346C0.332747 8.60013 0.332747 9.00013 0.599414 9.2668C0.732747 9.40013 0.866081 9.4668 1.06608 9.4668C1.26608 9.4668 1.39941 9.40013 1.53275 9.2668L5.33275 5.53346C5.59941 5.20013 5.59941 4.80013 5.33275 4.4668C5.33275 4.53346 5.33275 4.53346 5.33275 4.4668Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRightBlack);
export default __webpack_public_path__ + "static/media/angle-right-black.2ea7def0bbafbfbf5c685d5c4f483b4c.svg";
export { ForwardRef as ReactComponent };